import { useState} from 'react';
import { SelectBoxDate } from 'Elements';
// import { useDispatch } from 'react-redux';
// import { setSelectedFilter } from 'Actions';
import moment from 'moment-jalaali';
import styles from 'partials/filter-date-field.module.scss';

export const FilterBoxDateField = ({ onChange }) => {
	// const dispatch = useDispatch();
	const [state, setState] = useState({
		day: '',
		month: '',
		year: ''
	});

	const getDayItem = () => {
		const options = [];
		for (var i = 1; i <= 31; i++) {
			options.push({
				value: `${i}`,
				label: `${i}`,
				name: 'day'
			});
		}
		return options;
	};

	const getMonthItem = () => {
		return [
			{ value: '1', label: 'فروردین', name: 'month' },
			{ value: '2', label: 'اردیبهشت', name: 'month' },
			{ value: '3', label: 'خرداد', name: 'month' },
			{ value: '4', label: 'تیر', name: 'month' },
			{ value: '5', label: 'مرداد', name: 'month' },
			{ value: '6', label: 'شهریور', name: 'month' },
			{ value: '7', label: 'مهر', name: 'month' },
			{ value: '8', label: 'آبان', name: 'month' },
			{ value: '9', label: 'آذر', name: 'month' },
			{ value: '10', label: 'دی', name: 'month' },
			{ value: '11', label: 'بهمن', name: 'month' },
			{ value: '12', label: 'اسفند', name: 'month' }
		];
	};

	const getYearItem = () => {
		const year = [];
		for (let i = moment().jYear(); i >= 1300; i--) {
			year.push({
				value: `${i}`,
				label: `${i}`,
				name: 'year'
			});
		}
		return year;
	};

	const getValueFromOption = (options, value) => {
		return options.filter((option) => option.value === value);
	};

	const handleChange = (selected) => {
		const dateObj = { ...state };
		// console.log('dateObj: ', dateObj);
		dateObj[selected.name] = selected.value;

		const dateInput = `${dateObj.year}/${dateObj.month}/${dateObj.day}`;
		const momentDate = moment(dateInput, 'jYYYY/jMM/jDD')
			.startOf('day')
			.format('X');
		// console.log('momentDate: ', momentDate);

		setState({
			...state,
			day: dateObj.day,
			month: dateObj.month,
			year: dateObj.year
		});
		// dispatch(
		// 	setSelectedFilter({
		// 		name: `${range}_date`,
		// 		value: selected.value
		// 	})
		// );
		onChange?.(momentDate);
	};

	// const resetState = () => {
	// 	setState({
	// 		day: '',
	// 		month: '',
	// 		year: ''
	// 	});
	// };

	// useEffect(() => {
		// if (value) {
		// 	console.log('value: ', value);
		// 	setDateByValue();
		// } else {
		// 	resetState();
		// }
		// return () => {
		// 	console.log('unomint')
		// }
	// }, []);

	return (
		<div className={styles.box}>
			<div className={styles.field}>
				<SelectBoxDate
					name="day"
					options={getDayItem()}
					placeholder="روز"
					value={getValueFromOption(getDayItem(), state.day)}
					onChange={handleChange}
				/>
			</div>
			<div className={[styles.field, styles.fieldCenter].join(' ')}>
				<SelectBoxDate
					name="month"
					placeholder="ماه"
					options={getMonthItem()}
					value={getValueFromOption(getMonthItem(), state.month)}
					onChange={handleChange}
				/>
			</div>
			<div className={styles.field}>
				<SelectBoxDate
					name="year"
					placeholder="سال"
					options={getYearItem()}
					value={getValueFromOption(getYearItem(), state.year)}
					onChange={handleChange}
				/>
			</div>
		</div>
	);
};
